import React, { Component } from 'react';
import StatisticService from '../services/StatisticService';
import MenuComponent2 from './MenuComponent2';
import ReportBar from './ReportBar';
import ReportLine from './ReportLine';
import ReportRada from './ReportRada';

export default class Report extends Component {
  constructor(){
    super();
  }

  componentDidMount () { 
    this.loadData();
  }

  loadData() {
    StatisticService.getGhiLoiStatistics().then(data => {
      if (data !== undefined && data !== null && data instanceof Array) {
        this.setState({ data: data })
      }
    });
  }

  render() {
    return (
      <>
      <MenuComponent2 />
      <ReportLine></ReportLine>
      <br/>
      <ReportBar></ReportBar>
      <br/>
      <ReportRada></ReportRada>
      </>
    );
  }
}
